{
  "id": "default",
  "name": "Simple Orange",
  "sections": [
    {
      "id": "profilePhoto",
      "title": { "en": "Profile photo", "es": "Foto de perfil" },
      "type": "image",
      "fieldKey": "profileImage"
    },
    {
      "id": "identity",
      "title": { "en": "Personal Information", "es": "Información Personal" },
      "type": "form",
      "formGridClass": "form-grid form-grid--2",
      "fields": [
        {
          "id": "firstName",
          "label": { "en": "First Name", "es": "Nombre" },
          "inputType": "text"
        },
        {
          "id": "lastName",
          "label": { "en": "Last Name", "es": "Apellido" },
          "inputType": "text"
        },
        {
          "id": "headline",
          "label": { "en": "Headline", "es": "Título / Puesto" },
          "inputType": "text"
        },
        {
          "id": "birthDate",
          "label": { "en": "Date of Birth", "es": "Fecha de nacimiento" },
          "inputType": "text"
        },
        {
          "id": "age",
          "label": { "en": "Age", "es": "Edad" },
          "inputType": "text"
        },
        {
          "id": "location",
          "label": { "en": "Location", "es": "Ubicación" },
          "inputType": "text"
        }
      ]
    },
    {
      "id": "contact",
      "title": { "en": "Contact", "es": "Contacto" },
      "type": "form",
      "formGridClass": "form-grid form-grid--pair",
      "fields": [
        {
          "id": "cellPhone",
          "label": { "en": "Mobile", "es": "Celular" },
          "inputType": "text"
        },
        {
          "id": "email",
          "label": { "en": "Email", "es": "Email" },
          "inputType": "email"
        }
      ]
    },
    {
      "id": "summary",
      "title": { "en": "Professional Summary", "es": "Resumen Profesional" },
      "type": "text",
      "fieldKey": "summary"
    },
    {
      "id": "experience",
      "title": { "en": "Work Experience", "es": "Experiencia Laboral" },
      "type": "list",
      "listRowGridClass": "form-grid form-grid--2",
      "itemFields": [
        {
          "id": "company",
          "label": { "en": "Company", "es": "Empresa" },
          "inputType": "text"
        },
        {
          "id": "role",
          "label": { "en": "Role", "es": "Rol" },
          "inputType": "text"
        },
        {
          "id": "period",
          "label": { "en": "Period", "es": "Período" },
          "inputType": "text"
        },
        {
          "id": "details",
          "label": { "en": "Details", "es": "Detalles" },
          "inputType": "textarea"
        }
      ]
    },
    {
      "id": "education",
      "title": { "en": "Education", "es": "Educación" },
      "type": "list",
      "listRowGridClass": "form-grid form-grid--2",
      "itemFields": [
        {
          "id": "school",
          "label": { "en": "School", "es": "Institución" },
          "inputType": "text"
        },
        {
          "id": "degree",
          "label": { "en": "Degree", "es": "Título / Carrera" },
          "inputType": "text"
        },
        {
          "id": "period",
          "label": { "en": "Period", "es": "Período" },
          "inputType": "text"
        },
        {
          "id": "details",
          "label": { "en": "Details", "es": "Detalles" },
          "inputType": "textarea"
        }
      ]
    },
    {
      "id": "languages",
      "title": { "en": "Languages", "es": "Idiomas" },
      "type": "list",
      "listRowGridClass": "form-grid form-grid--pair",
      "itemFields": [
        {
          "id": "languageName",
          "label": { "en": "Language", "es": "Idioma" },
          "inputType": "text"
        },
        {
          "id": "languageLevel",
          "label": { "en": "Level", "es": "Nivel" },
          "inputType": "text"
        }
      ]
    },
    {
      "id": "additionalTraining",
      "title": {
        "en": "Additional Training & Courses",
        "es": "Formación y Cursos Adicionales"
      },
      "type": "list",
      "listRowGridClass": "form-grid form-grid--2",
      "itemFields": [
        {
          "id": "institution",
          "label": { "en": "Institution", "es": "Institución" },
          "inputType": "text"
        },
        {
          "id": "courseTitle",
          "label": { "en": "Title", "es": "Título" },
          "inputType": "text"
        },
        {
          "id": "coursePeriod",
          "label": { "en": "Period", "es": "Período" },
          "inputType": "text"
        }
      ]
    },
    {
      "id": "skills",
      "title": { "en": "Skills", "es": "Habilidades" },
      "type": "list",
      "listRowGridClass": "form-grid",
      "itemFields": [
        {
          "id": "skillName",
          "label": { "en": "Skill", "es": "Habilidad" },
          "inputType": "text"
        }
      ]
    }
  ]
}
